import { ChevronLeft } from 'lucide-react'
import { goBack } from '../router.js'
import { canonicalParentFor } from './site-navigation.js'

/**
 * RETOUR RÉEL (IA V2.1, §24-27) — « Retour » signifie REVENIR D'OÙ JE VIENS.
 *
 *   1. historique interne connu (profondeur > 0) → history.back() : l'URL
 *      précédente garde ses filtres/recherche/page, le scroll est restauré ;
 *   2. accès direct (favori, e-mail, nouvel onglet) → PARENT CANONIQUE du
 *      registre — jamais une expulsion hors de Gestion, jamais
 *      document.referrer comme logique produit.
 *
 * Le fil d'Ariane, lui, exprime le parent canonique (§22-23) — deux
 * concepts, deux composants.
 *
 * Le repli se calcule AU CLIC, sur l'adresse AFFICHÉE : un écran peut la
 * réécrire sans naviguer (l'assistant de clôture remplace
 * `/clotures/<uuid>` par `/clotures/<date>-<soirée>/nuit`), et le chemin du
 * routeur restait alors l'ancien — même écran, même adresse, deux Retours
 * différents selon qu'on avait rechargé ou non (revue du 07/10/2026).
 */
export function SmartBack({ fallback, label = 'Retour' }: { fallback?: string; label?: string }) {
  return (
    <button type="button" className="lc-crumb lc-smartback" onClick={() => goBack(fallback ?? canonicalParentFor(window.location.pathname))}>
      <ChevronLeft size={14} aria-hidden="true" /> {label}
    </button>
  )
}
